import { createDefault } from "../utils/ConstUtils";

export default createDefault([
  { value: 1, text: "買切", enum: "PURCHASE" },
  { value: 2, text: "委託", enum: "ENTRUST" },
  { value: 3, text: "消化仕入", enum: "DIGESTIVE" },
]);
